import { useEffect } from "react";
import type { DataRouter, RouterState } from "react-router";

type RouteMatchWithPath = { route: { path?: string } };

// Builds the route template ("/catalogue/:id") from the matched route definitions,
// so the real URL, its identifiers and its query string are never exposed.
export const getRoutePattern = (matches: RouteMatchWithPath[]): string | null => {
  if (matches.length === 0) return null;
  const pattern = matches.reduce((parentPattern, { route }) => {
    if (!route.path) return parentPattern;
    if (route.path.startsWith("/")) return route.path;
    return `${parentPattern.replace(/\/$/, "")}/${route.path}`;
  }, "");
  const normalizedPattern = pattern.replace(/\/{2,}/g, "/").replace(/(.)\/$/, "$1");
  return normalizedPattern.startsWith("/") ? normalizedPattern : `/${normalizedPattern}`;
};

export const useRouteViewTracking = (
  router: Pick<DataRouter, "state" | "subscribe">,
  onView: (pattern: string) => void,
) => {
  useEffect(() => {
    const emitView = (state: RouterState) => {
      if (state.navigation.state !== "idle") return;
      const pattern = getRoutePattern(state.matches);
      if (pattern) onView(pattern);
    };
    emitView(router.state);
    return router.subscribe(emitView);
  }, [router, onView]);
};
